// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Pqkqh","title":"Info_title__eqZKA","links":"Info_links__3jyJy","link":"Info_link__1ceQN","logo":"Info_logo__1Opc8"};